import { createFileRoute } from '@tanstack/react-router';
import { KpiCompetencyTable } from '@/modules/kpi/kpi-competency';

export const Route = createFileRoute('/(dashboard)/_dashboard/performance-review/$id/competency')({
  component: KpiCompetencyTable,
});
